import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import {
	type CardFilteredFlagProps,
	CardFilteredFlag,
} from '@atlassian/jira-software-flags/src/ui/card-filtered/index.tsx';
import { openIssueModal } from '../../state/actions/issue/modal/index.tsx';
import { addToSprintRequest } from '../../state/actions/sprints/add-to-sprint/index.tsx';
import {
	addToSprintSuccessSelector,
	addToSprintLoadingSelector,
} from '../../state/selectors/board/board-selectors.tsx';
import type { State } from '../../state/types.tsx';

type DispatchProps = Pick<CardFilteredFlagProps, 'onViewIssue' | 'onAddToSprint'>;
type StateProps = Pick<CardFilteredFlagProps, 'isAddedToSprintSuccess' | 'isAddedToSprintLoading'>;
type OwnProps = Omit<
	CardFilteredFlagProps,
	'onViewIssue' | 'onAddToSprint' | 'isAddedToSprintSuccess' | 'isAddedToSprintLoading'
>;

const mapStateToProps = (state: State): StateProps => ({
	isAddedToSprintSuccess: addToSprintSuccessSelector(state),
	isAddedToSprintLoading: addToSprintLoadingSelector(state),
});

const mapDispatchToProps = {
	onViewIssue: openIssueModal,
	onAddToSprint: addToSprintRequest,
} as const;

export default connect<StateProps, DispatchProps, OwnProps, State>(
	mapStateToProps,
	mapDispatchToProps,
)(CardFilteredFlag);
